export default __webpack_public_path__ + "static/media/Img3.173705b3.png";